import { faArrowRight } from "@jewlr/pro-solid-svg-icons/faArrowRight"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"

import ProductCard from "areas/landing/elements/landing-product/product-card"
import Button from "components/ui/button"
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "components/ui/carousel"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Media from "components/ui/media"
import { cn } from "styles/utils"

import ShopTheLookExpand from "./expand"

const ShopTheLookCarousel = ({ element }) => {
  const {
    data: { carousel_name, cta, cta_url, heading, products },
    style,
  } = element || { data: {} }
  const { classNames } = style || {}

  return (
    <div className={cn("widescreen:py-60 py-32", classNames?.blockClassName)}>
      <div
        className={cn(
          "desktop:items-center desktop:flex-row tablet:px-32 widescreen:px-60 flex flex-col px-16",
          element.contain !== false && "contained-wide",
          classNames?.containerClassName
        )}
      >
        <div className="desktop:basis-160 desktop:mb-0 desktop:mx-32 widescreen:mx-60 mb-8 shrink-0 grow-0">
          <h2 className="h2">
            {heading || (
              <>
                Shop <br className="desktop:block hidden" />
                the look
              </>
            )}{" "}
            <FontAwesomeIcon
              className="text-16 align-baseline"
              icon={faArrowRight}
            />
          </h2>
          {cta && cta_url && (
            <Button
              asChild
              className="tablet:inline-flex mt-20 hidden"
              variant="secondary"
            >
              <Link to={cta_url}>{cta}</Link>
            </Button>
          )}
        </div>
        <Media lessThan="tablet">
          <ShopTheLookExpand element={element} products={products} />
          {cta && cta_url && (
            <div className="text-center">
              <Button
                asChild
                className="tablet:inline-flex mt-20 hidden"
                variant="secondary"
              >
                <Link to={cta_url}>{cta}</Link>
              </Button>
            </div>
          )}
        </Media>
        <Media className="overflow-hidden" greaterThanOrEqual="tablet">
          <Carousel
            className={classNames?.carouselClassName}
            description={carousel_name}
          >
            <CarouselContent
              className={classNames?.carouselContentClassName}
              viewportClassName={cn(
                "mask-fade-right",
                classNames?.viewportClassName
              )}
            >
              {products.map((product, i) => (
                <CarouselItem
                  className={cn(
                    "desktop:pl-32 basis-[23%] pl-16",
                    classNames?.carouselItemClassName
                  )}
                  key={`${product.style_code}-${i}`}
                >
                  <ProductCard
                    element={element}
                    imageSizes={
                      classNames?.imageSizes ||
                      "(max-width: 767px) 50vw, (max-width: 1023px) 23vw, (max-width: 1439px) calc(((100vw - 288px) * 0.23) - 32px)), (max-width: 1920px) calc(((100vw - 400px) * 0.23) - 32px)), 318px"
                    }
                    index={i}
                    product={product}
                  />
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="tablet:inline-flex" />
            <CarouselNext className="tablet:inline-flex" />
          </Carousel>
        </Media>
      </div>
    </div>
  )
}

ShopTheLookCarousel.propTypes = {
  element: PropTypes.object,
}

export default ShopTheLookCarousel
